import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-border-title',
  templateUrl: './border-title.component.html',
  styleUrls: ['./border-title.component.scss']
})
export class BorderTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
